import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Content = styled.div`
  ${({ divPadding }) => `
    padding-left: ${divPadding}px;
    padding-right: ${divPadding}px;
  `}
  position: relative;
  z-index: 1;
`;

export const SearchWrapper = styled.div`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  float: right;

  > svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 20px;
    fill: #183748;
  }
`;

export const Input = styled.input`
  width: 74px;
  height: 36px;
  border-radius: 4px;
  margin-left: 50px;
  color: #183748;
  font-size: 10px;
  letter-spacing: 2px;
  line-height: 14px;

  &:focus {
    width: 200px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/TopMenu/styledComponents.js